import {Injectable} from '@angular/core';
import {ServerService} from '../services/server.service';
import {DataService} from "../services/data.service";
import {PuntoVendita, PuntoVenditaData} from "./PuntoVendita";
import _ from "lodash";

export class PVenditaUtenteData{
   id?: number;
   p_vendita?: PuntoVenditaData;
   pvendita_role?: number;
   p_vendita__nome?: string;
   is_commesso?: boolean;
   is_gestore?: boolean;
   esercizio_utente?: number;
   user?: number;
}


export class PVenditaUtente {

   public data: PVenditaUtenteData = {}

   ID!: number;
   p_vendita!: PuntoVendita

   constructor(data:PVenditaUtenteData = {}) {

      if(!data) data = {}

      Object.assign(this.data, data);

      if (data.p_vendita && !_.isNumber(data.p_vendita)){
         this.p_vendita = new PuntoVendita(data.p_vendita)
      }

      if (this.data.id != null) {
         this.ID = this.data.id;
      }
   }

   public static PermessiEsercizioUser = [
      {display:"Non Assegnato", value:"0"},
      {display:"Amministrativo", value:"10"},
      {display:"Gestore", value:"20"},
   ]

   public static PermessiPVenditaUser = [
      {display:"Non Assegnato", value:"0"},
      {display:"Venditore", value:"10"},
      {display:"Gestore", value:"20"},
      {display:"Manager", value:"30"},
   ]

   public static PermessiPVenditaUserChoices =
      {
         'NonAssegnato':0,
         'Venditore':10,   // Commesso
         'Gestore':20,     // Gestore Web
         'Manager':30,     // Store Manager
         'NonPermesso':99  // Sempre Negato
      }

   public static PermessiEsercizioUserChoices =
      {
         'NonAssegnato':0,
         'Amministrativo':10, // Amministrativo
         'Gestore':20,        // Manager Esercizio
         'NonPermesso':99     // Sempre Negato
      }

}


@Injectable({
   providedIn: 'root'
})
export class PVenditaUtenteFactory {

   constructor(private serverSrv:ServerService,
               private dataSrv:DataService) {

   }

   async getPVenditaUtenti(user_id, esercizio_utente): Promise<PVenditaUtente[]> {
      let url = `/api/utenti/${user_id}/esercizi_utente/${esercizio_utente}/pvendita_utenti`
      return new Promise<PVenditaUtente[]>((resolve, reject) => {
         this.serverSrv.getAll(PVenditaUtente, url)
            .then(res=>{resolve(res)})
            .catch(err=>{reject(err)})
      })
   }

   async getPVenditaUtente(user_id, esercizio_utente, pvendita_id): Promise<PVenditaUtente> {
      let url = `/api/utenti/${user_id}/esercizi_utente/${esercizio_utente}/pvendita_utenti/${pvendita_id}`
      return new Promise<PVenditaUtente>((resolve, reject) => {
         this.serverSrv.get(PVenditaUtente, url)
            .then(res=>{resolve(res)})
            .catch(err=>{reject(err)})
      })
   }

   async editPVenditaUtente(user_id, esercizio_utente, pvendita_id, data): Promise<PVenditaUtente> {
      //ToDo Sistemare edit
      let url = `/api/utenti/${user_id}/esercizi_utente/${esercizio_utente}/pvendita_utenti/${pvendita_id}/pvendita`
      return new Promise<PVenditaUtente>((resolve, reject) => {
         this.serverSrv.put(url, data, PVenditaUtente)
            .then(res=>{resolve(res)})
            .catch(err=>{reject(err)})
      })
   }




}


